/** --------------------------------------------------------
* Author Tien Tran
* Email tientran0019@gmail.com
* Phone 0972970075
*
* Created: 2024-06-06 10:13:49

* Last updated on: 2024-06-06 10:13:49
* Last updated by: Tien Tran
*------------------------------------------------------- */

"use client";

import React from "react";

import { SxProps, AvatarProps, Avatar as AvatarMui } from "@mui/material";

export function stringToColor(string: string | undefined | null) {
	if (!string) {
		return "";
	}
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = "#";

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */

	return color;
}

export function stringAvatar(name: string | undefined | null) {
	if (!name) {
		return {};
	}
	return {
		children: `${name.split(" ")?.[0]?.[0] ?? ""}${name.split(" ")?.[1]?.[0] ?? ""}`,
	};
}

type PropTypes = AvatarProps & {
	src?: string | undefined | null;
	alt?: string | undefined | null;
	size?: number;
	sx?: SxProps;
	bgcolor?: string;
};

const Avatar: React.FC<PropTypes> = (props) => {
	const { src, sx, alt, size = 40, bgcolor, ...attrs } = props;

	return (
		<AvatarMui
			{...attrs}
			// {...stringAvatar(alt)}
			sx={{
				height: size + "px",
				width: size + "px",
				fontSize: ((sx?.width ?? size) / 2.5).toFixed(0) + "px",
				bgcolor: src ? "#fff" : bgcolor ? bgcolor : stringToColor(alt),
				color: "#fff",
				...sx,
				"& img": {
					height: "auto !important",
				},
			}}
			src={src ?? ""}
			alt={alt ?? ""}
		/>
	);
};

export default React.memo(Avatar);
